import React, { ReactNode } from 'react';
import classNames from 'classnames/bind';
import styles from './SearchResultTableHeader.module.scss';

const cx = classNames.bind(styles);

interface SearchResultTableHeaderProps {
  title: ReactNode;
  totalResults?: number;
  icon?: ReactNode;
}

const SearchResultTableHeader = ({ title, totalResults, icon }: SearchResultTableHeaderProps): React.ReactElement => {
  return (
    <div className={cx('body')}>
      <h2 className={cx('title')} data-testid="search-result-table-title">
        {title}
      </h2>
      {icon}
      {(totalResults || false) && (
        <span className={cx('total-results')}>
          {totalResults} {totalResults > 1 ? 'Results' : 'Result'}
        </span>
      )}
    </div>
  );
};

export default SearchResultTableHeader;
